import { getBrandName } from '../brand-name';

export function getIsAcceptedFreebetMessage(): boolean {
  const brandName = getBrandName();

  switch (brandName) {
    case 'tennisi':
      return true;
    case 'chesnok':
      return true;
    case 'komyob':
      return false;
    default:
      assertExhaustiveness(brandName);
  }
}
